import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <main className="relative isolate min-h-screen">
      <img
        alt=""
        src="/assets/img/rose-background.jpg"
        className="absolute inset-0 -z-10 size-full object-cover object-top lg:object-center"
      />
      <div className="mx-auto max-w-7xl px-6 py-32 text-center sm:py-40 lg:px-8">
        <div className="flex justify-center mb-8">
          <img src="/site-logo.png" alt="Onyx Rose Advisors" className="h-16 w-auto" />
        </div>
        <p className="text-base/8 font-semibold text-accent">404</p>
        <h1 className="mt-4 text-5xl font-semibold tracking-tight text-balance text-slate-700 sm:text-7xl">
          Page not found
        </h1>
        <p className="mt-6 text-lg font-medium text-pretty text-slate-700 sm:text-xl/8">
          Sorry, we couldn't find the page you're looking for.
        </p>
        <div className="mt-10 flex justify-center">
          <Link to="/" className="text-sm/7 font-semibold text-slate-700 hover:text-accent transition-colors duration-200">
            <span aria-hidden="true">&larr;</span> Back to home
          </Link>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
